import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { AppInsightsTabsProps } from "./types";

/**
 * Section tabs for the app-insights card ("App Profile" / "ASO Report").
 * Pure presentational: an underlined tab strip in the same visual language as
 * the Price card's level tabs. The host owns `activeTab` and decides what each
 * tab opens — a modal, a route, or an inline section.
 */
export const AppInsightsTabs: React.FC<AppInsightsTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
}) => (
  <div className={cs(styles.tabs, className)} role="tablist">
    {tabs.map((tab) => {
      const active = tab.id === activeTab;

      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active}
          disabled={tab.disabled}
          className={cs(styles.tab, { [styles.tabActive]: active })}
          onClick={() => onTabChange?.(tab.id)}
        >
          {tab.icon && <span className={styles.tabIcon}>{tab.icon}</span>}
          <span className={styles.tabLabel}>{tab.label}</span>
          {tab.badge != null && (
            <span className={styles.badge}>{tab.badge}</span>
          )}
          {active && <span className={styles.underline} aria-hidden />}
        </button>
      );
    })}
  </div>
);

export default AppInsightsTabs;
